export default __webpack_public_path__ + "static/media/entries.931bc7b7.svg";